import ListingCard, { ListingCardProps } from 'components/listing-card/listing-card-v2';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';
import type { ComparableListing, SimilarListing } from '../similar-listings';
import { PROPERTY_FAVOURITED_SOURCE_ADDRESS_PAGE } from '@bedrock/analytics';

export type SimilarListingsGridProps = {
  listings: SimilarListing[];
  listingToCompare?: ComparableListing;
  onListingCardClick: ListingCardProps['onListingCardClick'];
};

const SIMILAR_LISTINGS_GRID_FAVOURITE_SOURCE = {
  favouriteSource: PROPERTY_FAVOURITED_SOURCE_ADDRESS_PAGE,
} as const;

function SimilarListingsGrid({ listings, listingToCompare, onListingCardClick }: SimilarListingsGridProps) {
  const useMinimalStyle = listings?.length < 3;
  const className = buildClassName(styles['similar-listings'], useMinimalStyle && styles['minimal-listings']);

  return (
    <div data-testid="similar-listings" className={className}>
      {listings?.map((listing: SimilarListing, index: number) => (
        <div className={styles['card-wrapper']} key={index}>
          <ListingCard listing={listing} decorations={{ comparableData: listingToCompare }} onListingCardClick={onListingCardClick} compliance={listing?.compliance} analytics={SIMILAR_LISTINGS_GRID_FAVOURITE_SOURCE} />
        </div>
      ))}
    </div>
  );
}

export default SimilarListingsGrid;